var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('resource-form',{attrs:{"model":_vm.form.model,"schema":_vm.form.schema,"triggers":_vm.form.triggers,"no-form-group":true},on:{"submit":_vm.onFormSubmit}},[_c('button',{staticClass:"btn btn-default btn-sm",attrs:{"slot":"cancel","type":"button"},on:{"click":_vm.onCancelButtonClick},slot:"cancel"},[_vm._v("\n        Annuler\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17e530ac","hasScoped":false,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Users/UserNameUpdateForm.vue
// module id = 1752
// module chunks = 0